<div class="nft-lists-comp" infinite-scroll [infiniteScrollDistance]="0.1" 
[scrollWindow]="true" (scrolled)="onScrollDown()" [infiniteScrollDisabled]="busyGettingData">
    <div class="filterheader">
        <h2>Explore the NFT Marketplace</h2>
        <div class="overbtns" hidden>
            <i class="fa fa-angle-left arrows" (click)="scrollheader('left')"></i>
            <i class="fa fa-angle-right arrows" (click)="scrollheader('right')"></i>
            <div class="categorybtns" id="categoryBtns">
                <div class="pl-0 pr-0" *ngFor="let category of categoriesList">
                    <button class="btn1" [ngClass]="{'bt2' : category.id === selectedCategory }"
                        (click)='getSelectedCategory(category.id)'><a>{{category.name}}</a></button>
                </div>
            </div>
        </div>
    </div>
    <div class="row no-gutters mt-3 mb-3 align-items-center">
        <div class="col-lg-4 col-sm-12 col-xs-12 col-md-12">
            <div class="d-flex align-items-center s-con ml-15" *ngIf="false">
                <input type="text" class="s-input" placeholder="Search by name" [(ngModel)]="searchkey"
                    (input)="getCollectionsApiCall()">
                <i class="fa fa-search"></i>
            </div>
        </div>
        <div class="col-8 text-right">
            <div class="text-right d-inline-block mr-15">
                <span class="dropdown">
                    <div mat-flat-button class=" btn btn-primary dropdown-toggle" id="dropdownMenuButton"
                        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <div class="row no-gutters">
                            <div class="col-12">
                                <span class="text-truncate d-inline-block mt-1">{{chain}}</span>
                            </div>

                        </div>
                    </div>
                    <div class="dropdown-menu " aria-labelledby="dropdownMenuButton">
                        <span class="pointer">
                            <a class="dropdown-item fs-13 pointer" (click)="networkChange('poly')">Polygon</a>
                            <!-- <a class="dropdown-item fs-13 pointer" (click)="networkChange('sep')">Sepolia</a> -->
                        </span>


                    </div>
                </span>
            </div>

            <div class="text-right d-inline-block mr-15">
                <span class="dropdown">
                    <div mat-flat-button class=" btn btn-primary dropdown-toggle" id="dropdownMenuButton"
                        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <div class="row no-gutters">
                            <div class="col-2">
                                <i class="material-icons">sort</i>
                            </div>
                            <div class="col-10">
                                <span class="text-truncate d-inline-block mt-1">{{sortName == ''?'Sort
                                    By':sortName}}</span>
                            </div>

                        </div>
                    </div>
                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                        <span>
                            <ng-container *ngFor="let sort of sortByList">
                                <a class="dropdown-item fs-13" (click)="sortbyfilter(sort)">{{sort.name}}</a>
                            </ng-container>
                        </span>


                    </div>
                </span>
            </div>
        </div>

    </div>
    <section class="card-Sec">
        <div class="cards-con" *ngIf="collectionsList.length > 0">
            <ng-container *ngFor="let item of collectionsList">
                <div class="cards pointer" (click)="getdata(item)">
                    <div class="imagediv" [ngStyle]="{'background-image':' url(' + item.banner_image + ')'}">
                        <div class="pro-img" [ngStyle]="{'background-image':' url(' +item.orgnization_details
                        ?.organization_logo+ ')'}">
                        </div>
                    </div>
                    <div class="desc-con">
                        <h6 class="desc-h">{{item.name}}</h6>
                        <div class="dec">{{item.description}}</div>
                    </div>
                </div>
            </ng-container>
        </div>
        <div *ngIf="collectionsList?.length == 0">
            <div class="d-flex justify-content-center align-items-center mb-25 no-data-available">NO DATA AVAILABLE
            </div>
        </div>
    </section>

</div>